module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1hOGB"))).then(() => parcelRequire('1iHdE'));